
import { defineComponent, PropType } from 'vue'

import { CallStackFrame } from '~/types/types'

export default defineComponent({
  name: 'DependencyCodeBlock',
  data() {
    return {
      isOpen: false
    }
  },
  props: {
    snippet: {
      type: Object as PropType<CallStackFrame>,
      required: true
    },
    expand: {
      type: Boolean,
      default: false
    },
    snippetNumber: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showMethod(): boolean {
      return this.snippet.method !== '(unnamed)'
    }
  },
  methods: {
    toggleDetails() {
      const details = this.$refs.detailsRef as HTMLDetailsElement
      this.isOpen = details.open
    }
  }
})
